export default "__VITE_ASSET__rN4R4KBR__"